module.exports = __webpack_public_path__ + "hinted-Montserrat-ExtraLightItalic.34786bb3215369576d67.woff";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-Montserrat-ExtraLightItalic.woff
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-Montserrat-ExtraLightItalic.woff
// module chunks = 1